import { LogoutOutlined } from '@mui/icons-material'
import { Button, CircularProgress, Stack } from '@mui/material'
import { useAuthenticationModel } from 'domain/authentication/authentication.model'
import { HelpButton } from 'presentation/_shared/components/help_button/help_button'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TIME_LIMIT_FOR_HELPER_BUTTONS = 3000

/**
 * A page that displays a loading indicator.
 * @category General
 */
export function LoadingPage(props: {
  /** Whether to show helper buttons */
  helperButtonsEnabled?: boolean
}): JSX.Element {
  const { helperButtonsEnabled = false } = props
  const { t } = useTranslation()
  const { logout } = useAuthenticationModel()
  const [showHelp, setShowHelp] = useState(false)
  useEffect(() => {
    if (helperButtonsEnabled) {
      setTimeout(() => {
        setShowHelp(true)
      }, TIME_LIMIT_FOR_HELPER_BUTTONS)
    }
  }, [helperButtonsEnabled])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100vh',
        padding: 20,
      }}
    >
      <div
        style={{
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress aria-label='loading' />
      </div>
      {showHelp && (
        <Stack
          direction='row'
          spacing={2}
          style={{
            position: 'absolute',
            bottom: 20,
            right: 20,
          }}
        >
          <HelpButton size='small' />
          <Button
            onClick={() => logout()}
            variant='text'
            size='small'
            color='error'
            startIcon={<LogoutOutlined />}
          >
            {t('log_out')}
          </Button>
        </Stack>
      )}
    </div>
  )
}
